<template>
  <div class="OSDI">
    <div class="OSDICon">
      <div class="title">干眼问卷调查表</div>
      <div class="loopData">
        <span class="tip">{{ data0.tip }}</span>
        <h4 class="smtitle">{{ data0.title }}</h4>
        <el-radio-group v-model="radiovalue0" size="medium" style="display: flex; flex-wrap: wrap">
          <div style="width: 100%; display: flex">
            <el-radio @change="radioClick" label="0" border>无</el-radio>
            <el-radio @change="radioClick" label="1" border>1年以内</el-radio>
            <el-radio @change="radioClick" label="2" border>2年以内</el-radio>
            <el-radio @change="radioClick" label="3" border>5年以内</el-radio>
            <el-radio @change="radioClick" label="4" border>5年以上</el-radio>
          </div>
          <h4 class="smtitle">或您已行角膜屈光手术多长时间？</h4>
          <div style="width: 100%; display: flex">
            <el-radio @change="radioClick" label="5" border>无</el-radio>
            <el-radio @change="radioClick" label="6" border>半年</el-radio>
            <el-radio @change="radioClick" label="7" border>1年</el-radio>
            <el-radio @change="radioClick" label="8" border>2年</el-radio>
            <el-radio @change="radioClick" label="9" border>2年以上</el-radio>
          </div>
        </el-radio-group>
        <i style="float: right; font-style: normal; padding-right: 19px; color: red"
          >*以上两问二选一</i
        >
      </div>
      <!-- <div class="loopData" style="overflow:hidden">
        <h4 class="smtitle">{{data0.title}}</h4>
        <el-radio-group v-model="radiovalue0" size="medium">
          <el-radio  @change="radioClick(index)" v-for="(item, index) in data0.item" :label="item.score" :key="index" border>{{item.text}}</el-radio>
        </el-radio-group>
        <i style="float: right;font-style: normal;padding-right: 19px;color: red;">*以上两问二选一</i>
      </div> -->
      <div class="loopData">
        <h4 class="smtitle">{{ data2.title }}</h4>
        <el-radio-group v-model="radiovalue2" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data2.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data3.title }}</h4>
        <el-radio-group v-model="radiovalue3" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data3.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data4.title }}</h4>
        <h5 class="solution">（a鼻子 b嘴巴 c喉咙 d皮肤 e生殖器）</h5>
        <el-radio-group v-model="radiovalue4" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data4.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <!-- -- -->
      <div class="loopData">
        <h4 class="smtitle">{{ data5.title }}</h4>
        <h5 class="solution">（a抽烟环境 b油烟环境 c空气污染环境 d粉尘环境 e空调环境 f暖气）</h5>
        <el-radio-group v-model="radiovalue5" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data4.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data6.title }}</h4>
        <h5 class="solution">
          （a抗过敏药 b利尿药 c降压药 d安眠药 e精神病类用药 f避孕药 g更年期治疗药物）
        </h5>
        <el-radio-group v-model="radiovalue6" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data4.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <!-- -- -->
      <div class="loopData">
        <span class="tip">{{ data7.tip }}</span>
        <h4 class="smtitle">{{ data7.title }}</h4>
        <el-radio-group v-model="radiovalue7" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data7.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data8.title }}</h4>
        <el-radio-group v-model="radiovalue8" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data7.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data9.title }}</h4>
        <el-radio-group v-model="radiovalue9" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data7.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data10.title }}</h4>
        <el-radio-group v-model="radiovalue10" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data7.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data11.title }}</h4>
        <el-radio-group v-model="radiovalue11" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data7.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ data12.title }}</h4>
        <el-radio-group v-model="radiovalue12" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data7.item"
            :label="item.score"
            :key="index"
            border
            >{{ item.text }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
  </div>
</template>
<script>
import { isDefined } from "../../../../shared/utils";
export default {
  name: "DryEyeMain",
  data() {
    return {
      combineValue: "",
      forward: "up",
      radiovalue0: "",
      // radiovalue1: '',
      radiovalue2: "",
      radiovalue3: "",
      radiovalue4: "",
      // ---
      radiovalue5: "",
      radiovalue6: "",
      radiovalue7: "",
      radiovalue8: "",
      radiovalue9: "",
      // ---
      radiovalue10: "",
      radiovalue11: "",
      radiovalue12: "",
      data0: {
        tip: "有关病史：",
        title: "1.您已戴隐形眼镜多长时间？",
        item: [
          { text: "无", score: "0" },
          { text: "一年内", score: "1" },
          { text: "2年内", score: "2" },
          { text: "5年以内", score: "3" },
          { text: "5年以上", score: "4" },
          { text: "无", score: "0" },
          { text: "半年", score: "1" },
          { text: "一年", score: "2" },
          { text: "两年", score: "3" },
          { text: "两年以上", score: "4" }
        ]
      },
      // data1: {title: '或您已行角膜屈光手术多长时间?', item: [{text: '无', score: '0'}, {text: '半年', score: '1'}, {text: '一年', score: '2'}, {text: '两年', score: '3'}, {text: '两年以上', score: '4'}]},
      data2: {
        title: "2 .您平均每天用眼药次数及时间",
        item: [
          { text: "无", score: "0" },
          { text: "≤4次/日3个月以下", score: "1" },
          { text: "≤4次/日3个月及以上", score: "2" },
          { text: ">4次/日3个月以下", score: "3" },
          { text: ">4次/日3个月及以上", score: "4" }
        ]
      },
      data3: {
        title: "3 .您晚上睡眠质量如何?",
        item: [
          { text: "睡眠很好", score: "0" },
          { text: "偶尔失眠或者熬夜", score: "1" },
          { text: "经常失眠或者熬夜", score: "2" },
          { text: "大部分时间睡眠质量差", score: "3" },
          { text: "每天睡眠质量都很差", score: "4" }
        ]
      },
      data4: {
        title: "4 .您以下部位是否觉得干燥？",
        item: [
          { text: "无", score: "0" },
          { text: "1种", score: "1" },
          { text: "2种", score: "2" },
          { text: "3种", score: "3" },
          { text: "≥4种", score: "4" }
        ]
      },
      data5: { title: "5 .您眼睛在以下环境是否敏感？", item: ["无", "1种", "2种", "3种", "≥4种"] },
      data6: { title: "6 .您是否长期服用以下药品？", item: ["无", "1种", "2种", "3种", "≥4种"] },
      //
      data7: {
        tip: "过去一周眼部症状：",
        title: "7.眼睛干燥感",
        item: [
          { text: "没有", score: "0" },
          { text: "偶尔", score: "1" },
          { text: "一半时间", score: "2" },
          { text: "大部分时间", score: "3" },
          { text: "全部时间", score: "4" }
        ]
      },
      data8: { title: "8.眼睛异物感" },
      data9: { title: "9.眼睛痛" },
      data10: { title: "10.眼睛畏光" },
      data11: { title: "11.晨起睫毛上是否有分泌物，睁眼困难" },
      data12: { title: "12.视力波动" }
    };
  },
  props: {
    history: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  mounted() {
    this.showHistory();
  },
  watch: {
    history(val) {
      this.showHistory();
    }
  },
  methods: {
    radioClick(index) {
      let wholeDataShow = true;

      let DryEyeMain = [
        this.combineValue,
        this.radiovalue2,
        this.radiovalue3,
        this.radiovalue4,
        this.radiovalue5,
        this.radiovalue6,
        this.radiovalue7,
        this.radiovalue8,
        this.radiovalue9,
        this.radiovalue10,
        this.radiovalue11,
        this.radiovalue12,
        this.forward
      ];
      this.$emit("emitDryEyeMainFun", DryEyeMain);

      if (this.radiovalue0 === "5") {
        this.combineValue = "0";
        this.forward = "down";
      } else if (this.radiovalue0 === "6") {
        this.combineValue = "1";
        this.forward = "down";
      } else if (this.radiovalue0 === "7") {
        this.combineValue = "2";
        this.forward = "down";
      } else if (this.radiovalue0 === "8") {
        this.combineValue = "3";
        this.forward = "down";
      } else if (this.radiovalue0 === "9") {
        this.combineValue = "4";
        this.forward = "down";
      } else {
        this.combineValue = this.radiovalue0;
        this.forward = "up";
      }
    },
    showHistory() {
      this.radiovalue0 = this.history[0];
      // console.log(this.radiovalue0)
      this.forward = this.history[12];
      // console.log(this.forward)
      if (this.forward === "down") {
        if (this.radiovalue0 === "4") {
          this.radiovalue0 = "9";
          this.combineValue = "4";
        } else if (this.radiovalue0 === "3") {
          this.radiovalue0 = "8";
          this.combineValue = "3";
        } else if (this.radiovalue0 === "2") {
          this.radiovalue0 = "7";
          this.combineValue = "2";
        } else if (this.radiovalue0 === "1") {
          this.radiovalue0 = "6";
          this.combineValue = "1";
        } else if (this.radiovalue0 === "0") {
          this.radiovalue0 = "5";
          this.combineValue = "0";
        } else {
          this.combineValue = this.radiovalue0;
        }
      } else {
        if (this.radiovalue0 === "4") {
          this.combineValue = "4";
        } else if (this.radiovalue0 === "3") {
          this.combineValue = "3";
        } else if (this.radiovalue0 === "2") {
          this.combineValue = "2";
        } else if (this.radiovalue0 === "1") {
          this.combineValue = "1";
        } else if (this.radiovalue0 === "0") {
          this.combineValue = "0";
        } else {
          this.combineValue = this.radiovalue0;
        }
      }
      // console.log(this.radiovalue0)
      // console.log(this.combineValue)
      // this.radiovalue1 = this.history[1]
      this.radiovalue2 = this.history[1];
      this.radiovalue3 = this.history[2];
      this.radiovalue4 = this.history[3];
      this.radiovalue5 = this.history[4];
      this.radiovalue6 = this.history[5];
      this.radiovalue7 = this.history[6];
      this.radiovalue8 = this.history[7];
      this.radiovalue9 = this.history[8];
      this.radiovalue10 = this.history[9];
      this.radiovalue11 = this.history[10];
      this.radiovalue12 = this.history[11];
    }
  }
};
</script>

<style lang="less" scoped>
.OSDI {
  color: #000;
  margin: auto;
  background: #fff;
  height: 100%;
  overflow: scroll;
  padding-left: 10px;
  margin-right: 4px;
  .OSDICon {
    .title {
      text-align: center;
      line-height: 100px;
      font-weight: bold;
      font-size: 24px;
      letter-spacing: 2px;
      font-size: 26px;
    }
    .smtitle {
      display: block;
      margin-bottom: 10px;
      font-size: 26px;
      font-weight: normal;
    }
    .solution {
      display: block;
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: 500;
    }
    .tip {
      color: #000;
      font-size: 26px;
    }
  }
}
/deep/ .el-radio-group {
  display: flex;
}
/deep/ .el-radio {
  position: relative;
  border: 1px solid #ccc;
  background-color: #fff;
  height: 45px;
  /* line-height: 45px; */
  text-align: center;
  flex: 1;
  /* flex-direction: column; */
  justify-content: space-around;
  font-size: 20px;
  margin-bottom: 20px;
  margin-right: 16px;
  cursor: pointer;
  transition: 0.5s;
  height: 65px !important;
  line-height: 43px !important;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio__label {
  color: #000;
  font-size: 26px !important;
}
/deep/ .is-checked {
  background: #409eff33;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/questions/CN/DryEyeMain.vue